<div mat-dialog-title>
    <h1 class="dialog-title">Claim Attachment</h1>
    <div class="justify-content-start mt-2 dialog-title-detail">
        <div>
            <span class="text-muted">Description: </span>{{ data.document.description }}
        </div>
        <div>
            <span class="text-muted">File Name: </span>{{ data.document.file_name }}
        </div>
    </div>
</div>
<div mat-dialog-content class="d-flex flex-column dialog-content">
    <div class="justify-content-center" *ngIf="!loadingFailed; else loadingFailedContainer">
        <div *ngIf="data.isImage; else fileContainer">
            <div *ngIf="loadingImage; else imageContainer">
                <mat-spinner></mat-spinner>
            </div>
            <ng-template #imageContainer>
                <img [src]="fileData" width="100%" height="auto" (error)="loadingFailed = true">
            </ng-template>
        </div>
        <ng-template #fileContainer>
            <div class="d-flex justify-content-center file-container">
                <mat-icon class="file-icon">insert_drive_file</mat-icon>
            </div>
        </ng-template>
    </div>
    <ng-template #loadingFailedContainer>
        <div class="justify-content-center">
            <p class="text-center">Failed to load attachment</p>
        </div>
    </ng-template>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="action-button" (click)="onDownloadClick()" [disabled]="loadingFailed">Download</button>
    <button mat-raised-button color="secondary" [mat-dialog-close]="true">Close</button>
</div>